module.exports = __webpack_public_path__ + "static/img/zhongBottomNew4.ff99ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/zhongBottomNew4.png
// module id = 6iQf
// module chunks = 0